export const formatPossession = (noun: string, something: string): string => {
  const endWithS = noun[noun.length - 1].toLowerCase() === "s";
  let formattedText: string;
  if (endWithS) {
    formattedText = `${noun}' ${something}`;
  } else {
    formattedText = `${noun}'s ${something}`;
  }
  return formattedText;
};
